<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/data-karyawan"
          :class="getRoute() === 'tables' ? 'active' : ''"
          navText="Data Karyawan"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-dark text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/data-absensi"
          :class="getRoute() === 'virtual-reality' ? 'active' : ''"
          navText="Data Absensi"
        >
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/verifikasi-absensi-mobile"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Verifikasi Absensi Mobile"
        >
          <template v-slot:icon>
            <i class="ni ni-camera-compact text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/data-payroll"
          :class="getRoute() === 'billing' ? 'active' : ''"
          navText="Data Payroll"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="isAdmin">
        <sidenav-item
          url="/manage-cuti-karyawan"
          :class="getRoute() === 'manage-cuti-karyawan' ? 'active' : ''"
          navText="Manage Cuti Karyawan"
        >
          <template v-slot:icon>
            <i class="ni ni-badge text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/pengumuman"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Pengumuman"
        >
          <template v-slot:icon>
            <i class="ni ni-notification-70 text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/setting"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Setting Approvals"
        >
          <template v-slot:icon>
            <i class="ni ni-active-40 text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/setting-shift"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Setting Shift"
        >
          <template v-slot:icon>
            <i class="ni ni-time-alarm text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="isAdmin">
        <sidenav-item
          url="/setting-potongan"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Setting Potongan"
        >
          <template v-slot:icon>
            <i class="ni ni-money-coins text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/office-location"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Lokasi Kantor"
        >
          <template v-slot:icon>
            <i class="ni ni-square-pin text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/device"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Device"
        >
          <template v-slot:icon>
            <i class="ni ni-tablet-button text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/account"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Account"
        >
          <template v-slot:icon>
            <i class="ni ni-satisfied text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="isAdmin">
        <sidenav-item
          url="/app-version"
          :class="getRoute() === 'rtl-page' ? 'active' : ''"
          navText="Update Aplikasi Mobile"
        >
          <template v-slot:icon>
            <i class="ni ni-spaceship text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="mt-3 nav-item">
        <h6
          v-if="this.$store.state.isRTL"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          صفحات المرافق
        </h6>
        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          ACCOUNT PAGES
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Profile'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/signin"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'تسجيل الدخول' : 'Sign In'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/signup"
          :class="getRoute() === 'signup' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'اشتراك' : 'Sign Up'"
        >
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('role') === 'Admin';
    }
  },
  components: {
    SidenavItem,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }
};
</script>
